module.exports = __webpack_public_path__ + "static/media/ft.497abf7a.png";